// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gaokao-nav[data-v-50da6037]{width:100%;display:flex;align-items:center;padding:20px 0}.gaokao-nav span[data-v-50da6037]{font-size:15px;color:#333;cursor:pointer}.gaokao-nav span[data-v-50da6037]:hover{opacity:.7}.gaokao-nav span[data-v-50da6037]:last-child{color:#333}", ""]);
// Exports
module.exports = exports;
